import { useEffect } from 'react'

export const useDocumentTitle = (title: string | null | undefined) => {
  useEffect(() => {
    if (title) document.title = title
  }, [title])
}
